import React from 'react'
import { formatDateStandard } from '../../../../global/formatters/string-formatter'
import { isIntervalFund } from '../../Helpers/CheckProductType'

export default function CapitalGainsEstimates({
  distributions,
  getDownload,
  fund,
}) {
  const estimates =
    distributions?.value?.productDetail?.capitalGainsEstimates[0]

  function renderDataPoint(data, unit) {
    return data === '-' ? data : unit === '$' ? unit + data : data + unit
  }

  const onClickDownloadCapGainsEstimates = (event) => {
    event.preventDefault()

    const capGainsParams = {
      type: isIntervalFund(fund.fundGroup) ? 'intervalEstimates' : 'estimates',
      period: null,
      className: null,
      cusip: fund.cusip,
    }

    const _url = getDownload(capGainsParams)

    window.location = _url
  }

  function renderTableBody() {
    return (
      <tr className="Table-row">
        <td className="Table-cell u-textRight">
          {formatDateStandard(estimates.recordDate)}
        </td>
        <td className="Table-cell u-textRight">
          {formatDateStandard(estimates.exDivdndDate)}
        </td>
        <td className="Table-cell u-textRight">
          {renderDataPoint(estimates.shortTermCapGainSt, '$') +
            ' - ' +
            renderDataPoint(estimates.shortTermCapGainEnd, '$')}
        </td>
        <td className="Table-cell u-textRight">
          {renderDataPoint(estimates.longTermCapGainSt, '$') +
            ' - ' +
            renderDataPoint(estimates.longTermCapGainEnd, '$')}
        </td>
        <td className="Table-cell u-textRight">
          {renderDataPoint(estimates.totalCapGainSt, '$') +
            ' - ' +
            renderDataPoint(estimates.totalCapGainEnd, '$')}
        </td>
        <td className="Table-cell u-textRight">
          {renderDataPoint(estimates.totalCapGainPctSt, '%') +
            ' - ' +
            renderDataPoint(estimates.totalCapGainPctEnd, '%')}
        </td>
      </tr>
    )
  }

  return (
    <div
      className="Content u-borderColorNeutralLight u-marginBottom3gu u-paddingTop0"
      id="mf-distributions-estimates"
    >
      <div className="Grid Grid--alignMiddle u-flexJustifyBetween u-marginBottom1gu">
        <div className="Content u-sizeFit u-sm-marginBottom3gu u-sm-sizeFull">
          <h3
            className="u-marginVert0"
            id="cap-gains-distributions-estimates-title"
          >
            Capital Gains Estimates{' '}
            <span className="u-sm-block u-sm-paddingTop1gu">
              as of {formatDateStandard(estimates.asOfDate)}
            </span>
          </h3>
        </div>
        <div className="u-sizeFit u-sm-sizeFull">
          <button
            className="Button Button--tertiary u-padding2gu u-textNoTransform"
            onClick={onClickDownloadCapGainsEstimates}
            data-analytics="download-cap-gains-estimates-details"
          >
            Download Capital Gains Estimates (csv)
          </button>
        </div>
      </div>

      <div className="u-overflowX u-marginBottom4gu">
        <table
          className="Table Table--reversed Table--striped"
          id="mf-distributions-estimates-table"
        >
          <thead className="Table-head">
            <tr className="Table-row">
              <th className="Table-header" colSpan="2"></th>
              <th
                className="Table-header Table-header--bracketed u-textCenter"
                colSpan="4"
              >
                Breakdown of Capital Gains Estimates Range
              </th>
            </tr>
            <tr className="Table-row">
              <th className="Table-header u-textRight">Record Date</th>
              <th className="Table-header u-textRight">Ex/Payable Date</th>
              <th className="Table-header u-textRight">
                Short-term Capital Gains
              </th>
              <th className="Table-header u-textRight">
                Long-term Capital Gains
              </th>
              <th className="Table-header u-textRight">Total Capital Gains</th>
              <th className="Table-header u-textRight">% of Record Date NAV</th>
            </tr>
          </thead>
          <tbody className="Table-body">{renderTableBody()}</tbody>
        </table>
      </div>
      <div className="Disclaimer">
        <div className="Disclaimer-text">
          <p>
            Capital gains estimates and dates listed above are subject to
            change.
          </p>
        </div>
      </div>
    </div>
  )
}
